import { FC } from 'react';
import { Formik } from 'formik';
import { Box, IconButton } from '@mui/material';
import { Form } from 'react-router-dom';

import styles from './ChatInput.module.scss';
import { ChatInputFormData } from '../../../../../../../types/aiChat.types';
import CustomInput from '../../../../../../../common/CustomInput';
import { SendMessageIcon } from '../../../../../../../components/Icons';

interface ChatInputProps {
  onSendMessage: (message: string) => Promise<void>;
  disabled?: boolean;
  placeholder?: string;
}

const ChatInput: FC<ChatInputProps> = ({ onSendMessage, disabled = false, placeholder = 'Type your message...' }) => {
  const initialValues: ChatInputFormData = {
    message: '',
  };

  const handleSubmit = async (values: ChatInputFormData, { resetForm }: any) => {
    if (!values.message.trim() || disabled) return;

    try {
      await onSendMessage(values.message);
      resetForm();
    } catch (error) {
      console.error('Failed to send message:', error);
    }
  };

  const validate = (values: ChatInputFormData) => {
    const errors: Partial<ChatInputFormData> = {};

    if (!values.message?.trim()) {
    }

    return errors;
  };

  return (
    <Box className={styles.chatInput}>
      <Formik
        initialValues={initialValues}
        validate={validate}
        onSubmit={handleSubmit}
      >
        {({ values, handleChange, handleSubmit, isSubmitting }) => {
          const canSend = values.message.trim().length > 0 && !disabled && !isSubmitting;

          const handleIconClick = (e: React.MouseEvent) => {
            e.preventDefault();
            if (canSend) {
              handleSubmit();
            }
          };

          return (
            <Form
              className={styles.inputForm}
              onSubmit={e => {
                e.preventDefault();
                if (canSend) {
                  handleSubmit();
                }
              }}
              onKeyDown={e => {
                if (e.key === 'Enter' && !e.shiftKey && canSend) {
                  e.preventDefault();
                  handleSubmit();
                }
              }}
            >
              <Box className={styles.inputWrapper}>
                <CustomInput
                  inputName="message"
                  value={values.message}
                  onChange={handleChange}
                  placeholder={placeholder}
                  disabled={disabled || isSubmitting}
                  customClass={styles.messageInput}
                  endIcon={
                    <IconButton
                      disabled={!canSend}
                      className={`${styles.sendButton} ${canSend ? styles.enabled : styles.disabled}`}
                      size="small"
                      onClick={handleIconClick}
                    >
                      <SendMessageIcon size={20} />
                    </IconButton>
                  }
                />
              </Box>
            </Form>
          );
        }}
      </Formik>
    </Box>
  );
};

export default ChatInput;
